import { useEffect } from "react";

export default function Seo({ title, siteName, description, image, jsonLd }) {
  useEffect(() => {
    const url = window.location.origin + window.location.pathname;
    const ensure = (sel, create) => {
      let el = document.head.querySelector(sel);
      if (!el) { el = create(); document.head.appendChild(el); }
      return el;
    };
    ensure('link[rel="canonical"]', () => { const l = document.createElement("link"); l.rel = "canonical"; return l; }).setAttribute("href", url);
    if (title) document.title = title;
    if (description) ensure('meta[name="description"]', () => { const m = document.createElement("meta"); m.name = "description"; return m; }).setAttribute("content", description);
    const og = (prop, val) => {
      if (!val) return;
      ensure(`meta[property="${prop}"]`, () => { const m = document.createElement("meta"); m.setAttribute("property", prop); return m; }).setAttribute("content", val);
    };
    og("og:url", url);
    og("og:title", title);
    og("og:description", description);
    og("og:site_name", siteName);
    og("og:type", "website");
    if (image) og("og:image", image.startsWith("http") ? image : window.location.origin + image);
    const tw = (name, val) => {
      if (!val) return;
      ensure(`meta[name="${name}"]`, () => { const m = document.createElement("meta"); m.name = name; return m; }).setAttribute("content", val);
    };
    tw("twitter:card", image ? "summary_large_image" : "summary");
    tw("twitter:title", title);
    tw("twitter:description", description);
    if (jsonLd) {
      const s = ensure('script[data-seo-jsonld]', () => { const el = document.createElement("script"); el.type = "application/ld+json"; el.setAttribute("data-seo-jsonld", "1"); return el; });
      s.textContent = JSON.stringify(jsonLd);
    }
  }, [title, siteName, description, image, jsonLd]);
  return null;
}
